import type {
    FutureStockQuantities,
    ProductOrderRestriction,
    StockQuantity,
} from '../types';
import { StockStatuses } from '../types';
import getMinimumStockStatus from './getMinimumStockStatus';
import getStockStatus from './getStockStatus';

const getGeneralStockStatuses = ({
    store,
    stock,
    futureStock,
    restriction,
    currentStockOnly = false,
}: {
    store: string;
    stock: StockQuantity[];
    futureStock: FutureStockQuantities[];
    restriction: ProductOrderRestriction[];
    currentStockOnly?: boolean;
}): { status: StockStatuses; isMixed?: boolean } => {
    if (stock.length === 0 && futureStock.length === 0) {
        return currentStockOnly
            ? {
                  status: StockStatuses.NOT_IN_STOCK,
              }
            : {
                  status: StockStatuses.CANNOT_BE_ORDERED_IN_DESIRED_BRANCH,
              };
    }

    const statuses = stock.map(
        stockItem =>
            getStockStatus({
                store,
                stock: stockItem,
                futureStock: futureStock.find(
                    item => item.sku === stockItem.sku
                ),
                restriction: restriction.find(
                    item => item.sku === stockItem.sku
                ),
                currentStockOnly,
            })[0].status
    );

    if (statuses.every(status => status === statuses[0])) {
        return {
            status: statuses[0],
        };
    }

    return {
        status: getMinimumStockStatus({
            store,
            stock,
            futureStock,
            restriction,
            currentStockOnly,
        }),
        isMixed: true,
    };
};

export default getGeneralStockStatuses;
